// extracted by mini-css-extract-plugin
export default {"scoreCardsContainer":"HTjQcMzQyE0wqG0tf6BP"};